import { render, staticRenderFns } from "./VCollapsePanel.vue?vue&type=template&id=21561cf1&"
import script from "./VCollapsePanel.vue?vue&type=script&lang=ts&"
export * from "./VCollapsePanel.vue?vue&type=script&lang=ts&"
import style0 from "./VCollapsePanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports